import React from 'react';
import { connect } from 'react-redux';
import './slide-status-overlay.css';
function SlideStatusOverlay({ _status }) {
    if (!_status || _status.state === 'idle') {
        return null;
    }
    return (React.createElement("div", { className: 'slide-status-overlay' },
        _status.state === 'generating' && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'slide-status-overlay__title' },
                "\u751F\u6210\u4E2D: ",
                _status.topic),
            React.createElement("div", { className: 'slide-status-overlay__progress-track' },
                React.createElement("div", { className: 'slide-status-overlay__progress-fill', style: { width: `${_status.progress ?? 0}%` } })),
            React.createElement("div", { className: 'slide-status-overlay__sub' },
                _status.progress ?? 0,
                "%\u00A0\u2014\u00A0",
                _status.statusLabel))),
        _status.state === 'ready' && (React.createElement("div", { className: 'slide-status-overlay__title' },
            "\u2713 \u6E96\u5099\u5B8C\u4E86: ",
            _status.topic)),
        _status.state === 'presenting' && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'slide-status-overlay__title' },
                "\u25B6 ",
                _status.topic),
            React.createElement("div", { className: 'slide-status-overlay__sub' },
                _status.currentSlide + 1,
                " / ",
                _status.totalSlides,
                " \u30DA\u30FC\u30B8")))));
}
function _mapStateToProps(state) {
    return {
        _status: state['features/slide-view']?.slideStatus ?? null
    };
}
export default connect(_mapStateToProps)(SlideStatusOverlay);
